import { Link, useLocation } from 'react-router-dom';
import type { CarbonIconType } from '@carbon/icons-react';
import styles from './SettingsNav.module.scss';

export interface SettingsNavItem {
  title: string;
  href: string;
  icon: CarbonIconType;
  description: string;
}

export interface SettingsNavProps {
  items: SettingsNavItem[];
}

function isNavItemActive(pathname: string, href: string): boolean {
  if (pathname === href) return true;
  if (href === '/settings/preferences' && pathname === '/settings') return true;
  return false;
}

export function SettingsNav({ items }: SettingsNavProps) {
  const location = useLocation();

  return (
    <nav className={styles.tabNav} aria-label="Sections des paramètres">
      <ul className={styles.tabList}>
        {items.map((item) => {
          const isActive = isNavItemActive(location.pathname, item.href);
          const Icon = item.icon;

          return (
            <li key={item.href} className={styles.tabItem}>
              <Link
                to={item.href}
                aria-current={isActive ? 'page' : undefined}
                title={item.description}
                className={`${styles.tabLink} ${isActive ? styles.tabLinkActive : styles.tabLinkInactive}`}
              >
                <span className={styles.tabIcon} aria-hidden>
                  <Icon size={18} />
                </span>
                <span className={styles.tabLabel}>{item.title}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
